<div class="d-flex breadcrumb-bar container-fluid" *ngIf="isLoggedIn">
  You are here:
  <ul class="breadcrumb">
    <li>
      <a routerLink="/home" routerLinkActive="menu-active">Business Hub</a>
      <span class="divider breadcrumb-divider"> &gt; </span>
    </li>
    <li *ngFor="let element of subBreadcrumbs">
      <a routerLink="{{ element.link }}" routerLinkActive="menu-active">{{ element.name }}</a>
      <span class="divider breadcrumb-divider"> &gt; </span>
    </li>
    <li class="active">{{ pageName }}</li>
  </ul>
</div>
